import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TokenService } from './token.service';

@Injectable({
  providedIn: 'root'
})
export class EchantillonageService {

  constructor(private http: HttpClient, private tokenService : TokenService) { }


  insererEchantillonageIso(options: object) {
    let httpHeaders = this.tokenService.loadToken();
    var request = "/api/echantillonage/inserer-iso";
    var jsonObject = {options : options}
    return this.http.post(request, jsonObject, {headers : httpHeaders });
  }


  getEchantillonageIso() {
    let httpHeaders = this.tokenService.loadToken();
    let request = "/api/echantillonage/get-iso";
    return this.http.get(request, {headers : httpHeaders});
  }


  getFichesNonEchantillonees() {
    let httpHeaders = this.tokenService.loadToken();
    let request = "/api/echantillonage/non-echantillonees";
    return this.http.get(request, {headers : httpHeaders});
  }


  setEchantillonageSurFiche(idModeration : number, ciblageOp:boolean,ciblageContenu:boolean,ciblageComplexite:boolean) {
    let httpHeaders = this.tokenService.loadToken();
    var request = "/api/echantillonage/set-cible-complexite";
    var jsonObject = {
      moderation : idModeration,
      op : ciblageOp,
      contenu : ciblageContenu,
      complexite : ciblageComplexite
    };
    return this.http.post(request, jsonObject, {headers : httpHeaders });
  }


  filtrerFiches(contenus:any[],complexites:string,operateurs:string) {
    let httpHeaders = this.tokenService.loadToken();
    var request = "/api/echantillonage/filtered-fiches";
    var jsonObject = {
      options : {
        contenus: contenus,
        complexites : complexites,
        operateurs : operateurs
      }
    };
    return this.http.post(request, jsonObject, {headers : httpHeaders });
  }


  sauvegarderFiltre(contenus:string,complexites:string,operateurs:string) {
    
    let httpHeaders = this.tokenService.loadToken();
    var request = "/api/echantillonage/sauvegarder-filtre";
    var jsonObject = {
      options : {
        contenus: contenus,
        complexites : complexites,
        operateurs : operateurs
      }
    };
    return this.http.post(request, jsonObject, {headers : httpHeaders });
  }


  getFiltres() {
    let httpHeaders = this.tokenService.loadToken();
    let request = "/api/echantillonage/filtres";
    return this.http.get(request, {headers : httpHeaders});
  }
}
